import { ContainerModule } from "inversify";
import {
  Base64DI,
  IBase64Converter
} from "@/core/common/converters/ports/Base64Convert";
import { Base64ConvertAdapter } from "@/core/common/converters/adapters/Base64ConvertAdapter";
import {
  Base64ToBlobConvertDI,
  IBase64ToBlobConvert
} from "@/core/common/converters/ports/Base64ToBlobConvert";
import { Base64ToBlobConvertAdapter } from "@/core/common/converters/adapters/Base64ToBlobConvertAdapter";

const convertersContainer = new ContainerModule((bind) => {
  bind<IBase64Converter>(Base64DI).to(Base64ConvertAdapter).inRequestScope();
  bind<IBase64ToBlobConvert>(Base64ToBlobConvertDI).to(
    Base64ToBlobConvertAdapter
  );
});

export { convertersContainer };
